import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-535867b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "btn-click",
  class: "menu-button-container",
  for: "menu-toggle"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-button" })
], -1))

import { ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonBurger',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      id: "menu-toggle",
      type: "checkbox",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }),
    _hoisted_1
  ]))
}
}

})